import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a44d841&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5a44d841&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44d841",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a44d841')) {
      api.createRecord('5a44d841', component.options)
    } else {
      api.reload('5a44d841', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a44d841&scoped=true&", function () {
      api.rerender('5a44d841', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuremanagement/ageGroupList/index.vue"
export default component.exports